export default __webpack_public_path__ + "static/TSA_Logo-e2ba21c7c6758cf15d2d808757b31f70.png";